import { required, integer, helpers } from 'vuelidate/lib/validators';

const isEmpty = (value) => value === '' || value === null || value === undefined;

const notNegative = helpers.withParams(
  { type: 'notNegative' },
  (value) => isEmpty(value) || Number(value) >= 0,
);

const maxValue = (max) => helpers.withParams(
  { type: 'maxValue', max },
  (value) => isEmpty(value) || Number(value) <= max,
);

const validations = {
  lookbackDays: {
    required,
    integer,
    notNegative,
  },
  articleCount: {
    required,
    integer,
    notNegative,
    maxValue: maxValue(10),
  },
};

export default validations;
